/* eslint-disable react/jsx-props-no-spreading */
import firebase from "firebase";
import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Loader from './components/Loader';
import Context, { useInitialState } from './config/context/context';
import { FIREBASE_CONFIG } from "./config/firebase/constants";
import { COLORS } from './constants/colors';
import './css/base.css';
import { getRoutes } from './routes';
import './scss/style.scss';

const onAppInitializeFormalities = () => {
	firebase.initializeApp(FIREBASE_CONFIG);
	document
		.querySelector('meta[name="theme-color"]')
		.setAttribute('content', COLORS.APP_BASE_COLOR);
}

const App = () => {

	useEffect(() => {
		onAppInitializeFormalities()
	}, []);

	return (
		<Context.Provider value={useInitialState()}>
			<BrowserRouter>
				<React.Suspense fallback={Loader}>
					<Switch>
						{getRoutes()?.map((route) => {
							const { exact, path, name, component } = route;
							return (
								component && (
									<Route
										exact={exact}
										path={path}
										name={name}
										render={(props) => <route.component {...props} />}
									/>
								)
							);
						})}
					</Switch>
				</React.Suspense>
			</BrowserRouter>
		</Context.Provider>
	);
};

export default App;
